export default __webpack_public_path__ + "static/media/up.c7e4d630.svg";